import styled from 'styled-components'

export const BodyDrawer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .map-content {
    min-width: 100%;
    max-width: 500px;
    height: 50vh;
    position: relative;
    overflow: hidden;

    .btn-edit-talhao {
      position: absolute;
      z-index: 99999;
      right: 20;
      margin: 15px;
      border-radius: 5px;
    }
  }
`